import { useState } from 'react';
import { BigNumber, ethers, providers } from 'ethers'
import { SC_ADDRESS, USDT_ADDRESS } from '../../constants/eth/addresses';
import HPContract from '../eth-abis/HPContract.json'
import usdt from "../eth-abis/usdt.json"
import { notify } from '../../utils/notifications';
declare let window: any;
async function requestAccount() {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
}

export async function PlaceBet(amount: number, bet_on: number, odds: number, betId: number) {
    if (typeof window.ethereum !== 'undefined') {
        await requestAccount()
        const provider = new providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()
        const better = await signer.getAddress();
        console.log(better)
        const SC = new ethers.Contract(SC_ADDRESS, HPContract.abi, signer)
        const USDToken = new ethers.Contract(USDT_ADDRESS, usdt.usdt, signer)
        try {
            let transaction1 = await USDToken.approve(SC.address, amount)
            await transaction1.wait()
            console.log(better, amount / 10 ** 6, bet_on, Math.floor(odds * 100), betId)
            let transaction2 = await SC.process_initbet(better, amount / 10 ** 6, bet_on, Math.floor(odds * 100), betId)
            transaction2.wait()
            return transaction2.hash
        } catch (err: any) {
            console.log("Error: ", err)
            if (err.data) {
                return ('Error: ' + err.data.message)
            }
            return ('Error: ' + err.message)
        }
    }
    else {
        return "Error: Wallet not connected"
    }
}

export async function SettleBet() {
    if (typeof window.ethereum !== 'undefined') {
        await requestAccount()
        const provider = new providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()
        const better = await signer.getAddress();
        console.log(better)
        const SC = new ethers.Contract(SC_ADDRESS, HPContract.abi, signer)
        const USDToken = new ethers.Contract(USDT_ADDRESS, usdt.usdt, signer)
        try {
            let transaction2 = await SC.process_settle(1,1)
            transaction2.wait()
            return transaction2.hash
        } catch (err: any) {
            console.log("Error: ", err)
            if (err.data) {
                return ('Error: ' + err.data.message)
            }
            return ('Error: ' + err.message)
        }
    }
    else {
        return "Error: Wallet not connected"
    }
}
